import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
export const UploadMessage = ({ type, onClick }) => {
    const { t } = useTranslation();
    const text = type === 'upload-test-results' ? t('label.upload_test_results') : t('label.fill_out_intake');
    return (_jsx("div", Object.assign({ className: styles.wrapper }, { children: _jsx("div", Object.assign({ className: styles.uploadMessage, onClick: onClick }, { children: _jsx("span", Object.assign({ className: styles.text }, { children: text })) })) })));
};
